import {Flex, Text, Link, Box} from '@chakra-ui/layout';
import ordinal from 'ordinal';
import {Show} from '@chakra-ui/react';
import {OfferingDisplayItem} from '../../../hooks/current-asset-overview';
import {WidgetBoxWrapper} from './widget-box-wrapper';

interface ProductHeaderProps {
  title: string;
  subTitle?: string;
  href: string;
  totalPieces?: number | null;
  offeringDisplayItems?: OfferingDisplayItem[];
}

export const ProductHeader: React.FC<ProductHeaderProps> = ({
  title,
  subTitle,
  href,
  offeringDisplayItems,
  totalPieces,
}) => {
  return (
    <Box mb={{lg: '20px'}}>
      <Show above="lg">
        <Flex
          direction="row"
          color="white"
          pb="5px"
          justify="space-between"
          align="center"
        >
          <Text pr="25px" textStyle={title.length <= 16 ? 'h6' : 'h5'}>
            {title}
          </Text>
          <Link
            width="107px"
            borderColor="white"
            borderWidth="2px"
            borderRadius="8px"
            href={href}
            pb="1px"
          >
            <Text
              as="span"
              textStyle="showpiece_h8"
              whiteSpace="nowrap"
              lineHeight="1"
              px={1}
            >
              Read the Story
            </Text>
          </Link>
        </Flex>
        {subTitle && (
          <Flex direction="column" color="white">
            <Text textStyle="body4">{subTitle}</Text>
          </Flex>
        )}
      </Show>
      <Show below="lg">
        <WidgetBoxWrapper>
          <Box p="16px">
            {totalPieces && (
              <Flex direction="column" color={{lg: 'white'}} mt="8px">
                <Text textStyle="h7">
                  {totalPieces.toLocaleString('en-US')} total pieces
                </Text>
              </Flex>
            )}
            {offeringDisplayItems &&
              offeringDisplayItems.length > 0 &&
              offeringDisplayItems.map((offering, index) => (
                <Flex direction="column" color={{lg: 'white'}} mt="8px">
                  <Text textStyle="h7">
                    {ordinal(index + 1)} release -{' '}
                    {offering.pieces?.toLocaleString('en-US')} pieces{' '}
                    {offering.available ? 'available now' : ''}{' '}
                    {!offering.available ? '- SOLD OUT' : ''}
                  </Text>
                </Flex>
              ))}
          </Box>
        </WidgetBoxWrapper>
      </Show>
      <Show above="lg">
        {totalPieces && (
          <Flex direction="column" color={{lg: 'white'}} mt="8px">
            <Text textStyle="h7">
              {totalPieces.toLocaleString('en-US')} total pieces
            </Text>
          </Flex>
        )}
        {offeringDisplayItems &&
          offeringDisplayItems.length > 0 &&
          offeringDisplayItems.map((offering, index) => (
            <Flex direction="column" color={{lg: 'white'}} mt="8px">
              <Text textStyle="h7">
                {ordinal(index + 1)} release -{' '}
                {offering.pieces?.toLocaleString('en-US')} pieces{' '}
                {offering.available ? 'available now' : ''}{' '}
                {!offering.available ? '- SOLD OUT' : ''}
              </Text>
            </Flex>
          ))}
      </Show>
    </Box>
  );
};
